import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkStatusService {
  private onlineStatusSubject: Subject<boolean> = new Subject<boolean>();

  constructor() {
    window.addEventListener('online', () => this.updateOnlineStatus(true));
    window.addEventListener('offline', () => this.updateOnlineStatus(false));
  }

  private updateOnlineStatus(isOnline: boolean): void {
    this.onlineStatusSubject.next(isOnline);
  }

  get onlineStatus$(): Observable<boolean> {
    return this.onlineStatusSubject.asObservable();
  }

  get isOnline(): boolean {
    return navigator.onLine;
  }
}